export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    goTownPoRTal() {
      // let url = location.protocol + '//' + location.host;
      // if (url.indexOf('test') >= 0) {
      //   window.open('http://test.caijiazhen.portal.jlncjy.cacfintech.com');
      // }
      // window.open('http://dev.caijiazhen.portal.jlncjy.cacfintech.com');
    }
  }
};
